var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"history"}},[_c('TopList',{attrs:{"navList":_vm.navList},on:{"setType":_vm.setType}}),(_vm.type === 0)?_c('Look'):_vm._e(),(_vm.type === 1)?_c('Down'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }